// libraries
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { get, filter, groupBy, maxBy, isEmpty } from "lodash";
import moment from "moment";

// Hooks
import buildValidParams from "@Hooks/useParamsFilter";

// Redux
import { connect } from "react-redux";

// Components
import IkTable from "@Components/IkTable";
import Screen from "@Components/Screen";

// Utils
import { dataHandler } from "@Utils";
import { dropdownFormat } from "@Utils/index";

// Actions
import genericAction from "@Actions/generic";

// Modals
import TemplateCrud from "./Modals/TemplateCrud";
import FilterForm from "./Modals/FilterModal";
import SendModalPlantilla from "./Modals/sendTemplates";

// Styles
import styles from "./styles.module.css";

const Templates = ({ dispatch, userName, companyName, channels, company }) => {
	// --- State ---
	const [openUsersCrud, setOpenUsersCrud] = useState(false);
	const [filteredItems, setFilteredItems] = useState([]);
	const [filteredCount, setFilteredCount] = useState(null);
	const [filteredPrintData, setFilteredPrintData] = useState([]);
	const [latestDateByContact, setLatestDateByContact] = useState(new Map());
	const defaultParams = {
		page: 1,
		orderKey: "templateLogs.id",
		orderDir: "desc",
		rows: 25,
	};
	const [lastParams, setLastParams] = useState(defaultParams);
	const [templateTable, setTemplateTable] = useState("");
	const [checkAllData, setCheckAllData] = useState([]);
	const [isSendTemplate, setIsSendTemplate] = useState(false);

	// Filter modal states
	const [channel, setChannel] = useState("");
	const [template, setTemplate] = useState("");
	const [startDateSent, setStartDateSent] = useState("");
	const [endDateSent, setEndDateSent] = useState("");
	const [startDateConfirmed, setStartDateConfirmed] = useState("");
	const [endDateConfirmed, setEndDateConfirmed] = useState("");
	const [nameFilter, setNameFilter] = useState("");
	const [phone, setPhone] = useState("");
	const [channelAll, setChannelAll] = useState(false);
	const [templateAll, setTemplateAll] = useState(false);
	const [openFilter, setOpenFilter] = useState(false);
	const [channelOption, setChannelOption] = useState([]);
	const [templateOption, setTemplateOption] = useState([]);
	const [state, setState] = useState("");
	const [group, setGroup] = useState(null);
	const [optionGroup, setOptionGroup] = useState([]);
	const [isFilterFirtTime, setIsFilterFirtTime] = useState(false);

	// --- Effects ---
	useEffect(() => {
		(async () => {
			const templatePromise = dispatch(genericAction({ method: "get", route: "templates/all" }));
			const groupPromise = dispatch(genericAction({ method: "get", route: "groups/all" }));
			const [templateResponse, groupResponse] = await Promise.all([templatePromise, groupPromise]);

			const currentOptionTemplate = dropdownFormat(templateResponse, "title", "id");
			const filteredChannels = filter(channels, (item) => {
				return item.platform.id === 2 || item.platform.id === 7;
			});
			const channelCurrentOption = dropdownFormat(filteredChannels, "label", "id");
			const groupCurrentOption = dropdownFormat(groupResponse, "name", "name");

			setChannelOption(channelCurrentOption);
			setTemplateOption(currentOptionTemplate);
			setOptionGroup(groupCurrentOption);
		})();
	}, [channels, dispatch]);

	// --- Handlers ---

	const handleChangeOption = () => {
		return setOpenFilter(true);
	};

	const buildLatestDatesMap = (items) => {
		const grouped = groupBy(items, (item) => {
			return `${item.contactId}_${item.templateId}`;
		});

		const mapResult = new Map();

		Object.entries(grouped).forEach(([key, groups]) => {
			const latestItem = maxBy(groups, (item) => {
				return moment(item.createdDate).valueOf();
			});
			if (latestItem) mapResult.set(key, moment(latestItem.createdDate));
		});

		return mapResult;
	};

	const handlerData = async (params, printable, findAll) => {
		let newParams = params;
		if (!params.all) {
			newParams = { ...params, all: "" };
			setLastParams((prev) => {
				return { ...prev, all: "" };
			});
		}
		const finalParams = buildValidParams(newParams, lastParams);
		const data = await dataHandler({ dispatch, url: "templatelogs", params: finalParams });

		if (!isEmpty(params.all))
			setLastParams((prev) => {
				return { ...prev, ...finalParams };
			});

		if (printable) setFilteredPrintData(data.items);
		if (findAll) setCheckAllData(data.items);
		else {
			parserItems(data);

			setLatestDateByContact(buildLatestDatesMap(data.items));
		}
	};

	const refresh = async () => {
		let newParams = lastParams;

		if (!isFilterFirtTime) {
			return;
		}

		if (isEmpty(newParams.all)) {
			newParams = buildValidParams(newParams, lastParams);
		}

		const profilesResponse = await dataHandler({ dispatch, url: "templatelogs", params: newParams });
		parserItems(profilesResponse);
		setLastParams(newParams);
		setLatestDateByContact(buildLatestDatesMap(profilesResponse.items));
	};

	const onFilter = async (params) => {
		const finalParams = buildValidParams(params, lastParams);

		const response = await dataHandler({ dispatch, url: "templatelogs", params: finalParams });

		parserItems(response);
		setLatestDateByContact(buildLatestDatesMap(response.items));
		setLastParams(finalParams);
		setOpenFilter(false);
	};

	const parserItems = (array) => {
		setFilteredCount(array.count);
		setFilteredItems(array.items);
	};

	const sendTemplates = () => {
		setIsSendTemplate(true);
	};

	const hasFiveMinutesPassed = (date) => {
		if (!date) return false;
		return moment().diff(moment(date), "minutes") >= 60;
	};

	const isVisibleForwar = (item) => {
		const { contactId, templateId } = item;
		const createdDate = moment(item.createdDate);
		const key = `${contactId}_${templateId}`;
		const latestDate = latestDateByContact.get(key);
		return hasFiveMinutesPassed(item.createdDate) && latestDate?.isSame(createdDate, "millisecond") && templateTable === "";
	};

	// 	setTemplateTable(value);
	// 	setTemplate("");
	// 	onFilter({ "templateLogs.templateId[]": value });
	// };

	const haveFilter = () => {
		return [channel, template, startDateSent, endDateSent, startDateConfirmed, endDateConfirmed, nameFilter, phone, state].some((value) => {
			return value !== "";
		});
	};

	const handleButton = (name, item) => {
		switch (name) {
			case "Forward":
				dispatch(
					genericAction({
						method: "post",
						route: "templates/send",
						body: {
							contactIds: [get(item, "contactId", null)],
							templateId: get(item, "templateId", null),
						},
						onSuccess: refresh,
					})
				);
				break;

			// case "onClick":
			// 	setSelectedItemTable(item);
			// 	break;
			case "Add":
				setOpenUsersCrud(true);
				break;

			default:
				break;
		}
	};

	return (
		<Screen hasHeader hasSidebar headerTitle="Plantillas">
			<div className={styles.container}>
				<div className={styles.containerTableGroup}>
					<div className={styles.tableGroupList}>
						<IkTable
							data={filteredItems}
							columns={[
								{
									hidden: templateTable === "",
									multiple: true,
									key: "id",
									dataPosition: "center",
									width: 1,
								},
								{
									label: "Acciones",
									action: [
										{
											content: "mail forward",
											color: "#3f7ea3",
											onClick: "Forward",
											type: "icon",
											visible: isVisibleForwar,
										},
									],
									dataPosition: "center",
									width: 1,
									canFilter: false,
									canSort: false,
								},
								{
									label: "ID-Envío",
									key: "id",
									format: "string",
									dataPosition: "center",
									width: 1,
									canFilter: false,
									canSort: false,
								},
								{
									label: "Contacto",
									key: "name",
									format: "string",
									headerPosition: "center",
									width: 1,
								},
								{
									label: "Grupo",
									key: "group",
									format: "string",
									headerPosition: "center",
									width: 1,
									canFilter: false,
									canSort: false,
									hidden: isEmpty(company.groups),
								},
								{
									label: "Teléfono",
									key: "phone",
									format: "phone",
									headerPosition: "center",
									width: 1,
								},
								{
									label: "Canal",
									key: "label",
									format: "phone",
									headerPosition: "center",
									width: 1,
									canFilter: false,
									canSort: false,
								},
								{
									label: "Nombre plantilla",
									key: "title",
									format: "string",
									headerPosition: "center",
									width: 1,
									canFilter: false,
									canSort: false,
								},
								{
									label: "Fecha de envío",
									key: "createdDate",
									format: "dateTime",
									headerPosition: "center",
									width: 1,
									canFilter: false,
									canSort: false,
								},
								{
									label: "Fecha Confirmación",
									key: "confirmedDate",
									format: "dateTime",
									headerPosition: "center",
									width: 1,
									canFilter: false,
									canSort: false,
								},
								{
									label: "Cant días",
									key: "createdDate",
									format: "timeBetween",
									headerPosition: "center",
									width: 1,
									canFilter: false,
									canSort: false,
								},
								{
									label: "Error",
									key: "error",
									format: "string",
									headerPosition: "left",
									width: 15,
									canFilter: false,
									canSort: false,
								},
							]}
							topButtons={[
								{
									componentType: "Button",
									content: haveFilter() ? "Filtros-1" : "Filtrar",
									icon: "filter",
									buttonContainerStyle: styles.filterButton,
									onClick: handleChangeOption,
									className: styles.buttonFilterTable,
								},
								{
									icon: "refresh",
									className: styles.refreshButton,
									onClick: (e) => {
										return refresh(e.target.value);
									},
								},
								// {
								// 	componentType: "DropDown",
								// 	options: templateOption,
								// 	value: templateTable,
								// 	clearable: true,
								// 	search: true,
								// 	// label: "Plantilla",
								// 	placeholder: "Seleccionar Plantilla",
								// 	onChange: (e, { value }) => {
								// 		return templateHandler(value);
								// 	},
								// 	className: styles.dropDownFilter,
								// },
								{
									componentType: "Button",
									content: `Enviar`,
									icon: "send",
									buttonContainerStyle: styles.filterButton,
									onClick: sendTemplates,
									className: styles.buttonTYemplateTable,
								},
							]}
							customSearchKeys={[
								{ label: "Fecha envio", key: "templateLogs.createdDate", format: "dateTime" },
								{ label: "Fecha Confirmación", key: "templateLogs.confirmedDate", format: "dateTime" },
								{ label: "Error", key: "templateLogs.error", format: "string" },
								{ label: "Contacto", key: "templateLogs.contactId" },
								{ label: "Canal", key: "templateLogs:channel.label", format: "string" },
								{ label: "Nombre Plantilla", key: "templateLogs:template.title", format: "string" },
								{ label: "Nombre", key: "templateLogs:template.title", format: "string" },
								{ label: "Grupo", key: "templateLogs.group", format: "string" },
							]}
							totalRows={filteredCount}
							filteredPrintData={filteredPrintData}
							defaultParams={lastParams}
							// handlerMultiple={handlerMultiple}
							checkAllData={checkAllData}
							dataHandler={handlerData}
							handlerTable={handleButton}
							addButton={{ label: "Plantillas" }}
							searcher={{ width: "40rem", filterButton: false }}
							print={{ printHeader: { company: companyName, title: "Plantillas", user: userName } }}
						/>
					</div>
				</div>
			</div>

			{openUsersCrud && (
				<TemplateCrud
					refresh={refresh}
					onClose={() => {
						return setOpenUsersCrud(false);
					}}
				/>
			)}

			{isSendTemplate && (
				<SendModalPlantilla
					onClose={() => {
						setIsSendTemplate(false);
					}}
					company={company}
				/>
			)}

			{openFilter && (
				<FilterForm
					onClose={() => {
						return setOpenFilter(false);
					}}
					onFilter={onFilter}
					channel={channel}
					setChannel={setChannel}
					template={template}
					setTemplate={setTemplate}
					startDateSent={startDateSent}
					setStartDateSent={setStartDateSent}
					endDateSent={endDateSent}
					setEndDateSent={setEndDateSent}
					startDateConfirmed={startDateConfirmed}
					setStartDateConfirmed={setStartDateConfirmed}
					endDateConfirmed={endDateConfirmed}
					setEndDateConfirmed={setEndDateConfirmed}
					name={nameFilter}
					setName={setNameFilter}
					phone={phone}
					setPhone={setPhone}
					channelAll={channelAll}
					setChannelAll={setChannelAll}
					templateAll={templateAll}
					setTemplateAll={setTemplateAll}
					channelOption={channelOption}
					templateOption={templateOption}
					setTemplateTable={setTemplateTable}
					templateTable={templateTable}
					state={state}
					setState={setState}
					group={group}
					setGroup={setGroup}
					optionGroup={optionGroup}
					company={company}
					isFilterFirtTime={isFilterFirtTime}
					setIsFilterFirtTime={setIsFilterFirtTime}
				/>
			)}
		</Screen>
	);
};

function mapStateToProps({ user, company }) {
	return {
		user,
		userName: user.name,
		companyName: company.name,
		channels: company.channels,
		company,
	};
}

Templates.propTypes = {
	companyName: PropTypes.string,
	userName: PropTypes.string,
	dispatch: PropTypes.func,
	channels: PropTypes.array,
	company: PropTypes.object,
};

export default connect(mapStateToProps)(Templates);
